import { SupportedLanguage } from 'src/i18n/types';

export const getPreferredLanguage: () => SupportedLanguage = () => {
  const language = localStorage.getItem('fdbt-dab-lng');

  return language === SupportedLanguage.Arabic
    ? SupportedLanguage.Arabic
    : SupportedLanguage.English;
};
